import type {
	LeasingDetailDataDTO,
	PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { LEASING_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/LeasingForm/leasingFormDefaults";
import type { LeasingFormInput } from "web_myplann/Portfolio/Forms/LeasingForm/leasingFormSchema";

export const mapPortfolioToLeasingForm = (
	portfolio: PortfolioDetailResponseDTO,
): LeasingFormInput => {
	const data = portfolio.data as LeasingDetailDataDTO | undefined;
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		productCategoryId:
			portfolio.productCategoryId ?? DEFAULTS.productCategoryId,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		fixationEndDate: parseIsoDate(data?.fixationEndDate),
		originalObligationAmount:
			data?.originalObligationAmount ?? DEFAULTS.originalObligationAmount,
		installment: data?.installment ?? DEFAULTS.installment,
		interestRate: data?.interestRate ?? DEFAULTS.interestRate,
		paymentFrequency: data?.paymentFrequency ?? DEFAULTS.paymentFrequency,
	};
};
